// extracted by mini-css-extract-plugin
export default {"task-side-footer":"styles_task-side-footer__DErWk"};